import React from "react";
import { Alert, Box, IconButton, Snackbar, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTabs } from "@context/TabsContext";
import { styles } from "./TabBar.styles";

const TabBar: React.FC = () => {
  const { tabs, activeTabId, setActiveTab, closeTab, warningOpen, dismissWarning } = useTabs();

  if (tabs.length === 0) return null;

  return (
    <>
      <Box sx={styles.root}>
        {tabs.map((tab) => (
          <Box key={tab.id} sx={styles.tab(tab.id === activeTabId)} onClick={() => setActiveTab(tab.id)}>
            <Typography sx={styles.label}>{tab.label}</Typography>
            <IconButton
              size="small"
              sx={styles.closeButton}
              onClick={(e) => {
                e.stopPropagation();
                closeTab(tab.id);
              }}>
              <Close />
            </IconButton>
          </Box>
        ))}
      </Box>
      <Snackbar
        open={warningOpen}
        autoHideDuration={4000}
        onClose={dismissWarning}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="warning" onClose={dismissWarning} sx={styles.alert}>
          Limite de 8 abas atingido. Feche uma aba para abrir outra.
        </Alert>
      </Snackbar>
    </>
  );
};

export default TabBar;
